// extracted by mini-css-extract-plugin
module.exports = {"dialogMain":"app_dialogMain__CfAMO"};